<template>
    <div><!--template should contain only one root element-->
        <div class="row wrap" v-if="type.role!='ambassador'">
            <div class="col-xs-12 col-md-8 col-lg-6 col-md-offset-2 col-lg-offset-3">
                <div v-if="currentComponent==null" class="form-group event-buttons-group">
                    <transition name="fade" appear>
                        <fieldset>
                            <legend class="hidden-xs">Choisir une action :
                                <button v-if="type.type =='ecole'" class="btn pull-right blue" @click="getHistory()"><i class="fas fa-history"></i></button>
                                <button v-if="type.type!='solo'"  id="btnGraph" class="btn pull-right" @click="displayGraph()"><i class="fas fa-chart-bar"></i></button>
                                <VueCtkDateTimePicker class="pull-right" v-if="showCal" no-value-to-custom-elem v-model="customResource" format="YYYY-MM-DD" only-date auto-close color="#70A6B2" no-button-now style="display: inline; width: 26rem">
                                    <button class="btn pull-right"><i class="far fa-calendar-alt"></i></button>
                                </VueCtkDateTimePicker>
                            </legend>
                            <div class="row wrap">
                                <div v-if="type.type!='solo'" class="col-xs-5 col-sm-3 col-md-3 no-right-padding" style="margin-bottom: .5rem">
                                    <button class="btn btn-block btnBooking" @click="bookingMultipleOpen()"><i class="fas fa-plus"></i> Collective</button>
                                </div>
                                <div class="col-xs-5 col-sm-3 col-md-3 no-right-padding" style="margin-bottom: .5rem;">
                                    <button class="btn btn-block btnBooking" @click="bookingOpen()"><i class="fas fa-plus"></i> Engagement</button>
                                </div>
                                <div class="col-xs-2 visible-xs no-h-padding" style="z-index: 9999!important">
                                    <VueCtkDateTimePicker class="visible-xs" v-if="showCal" no-value-to-custom-elem v-model="customResource" format="YYYY-MM-DD" only-date auto-close color="#70A6B2" no-button-now>
                                        <button class="btn btn-block"><i class="far fa-calendar-alt"></i></button>
                                    </VueCtkDateTimePicker>
                                </div>
                                <div class="col-xs-5 col-sm-3 col-sm-offset-0 no-left-padding" v-bind:class="{'col-sm-offset-6':type.type=='solo'}" style="margin-bottom: .5rem">
                                    <button class="btn btn-block blue" @click="create()"><i class="fas fa-plus"></i> Evénement</button>
                                </div>
                                <div v-show="type.type!='solo'" class="col-xs-12 col-sm-3">
                                    <a id="currentdayevents-btn" target="_blank" class="btn blue btn-block btn-right" @click="currentdayevents($event)"><i class="far fa-file-pdf"></i> RDV du jour</a>
                                </div>
                            </div>
                        </fieldset>
                    </transition>
                </div>
                <div v-if="currentComponent=='Booking'">
                    <transition name="fade" appear>
                        <calBooking
                                :users="users"
                                :renforts="renforts"
                                :calendarResources="calendarResources"
                                :userType="type"
                                :activities="activities"
                                :current="current"
                                :booking="booking"
                                :legend="legend"
                                :isEdited="isEdited"
                                :quickCreate="quickCreate"
                                :met="met"
                                :redirectbillingroute="redirectbillingroute"
                                :permissions="permissions"
                                @snotify="snotify"
                                @closeBooking="closeComponent"
                                @rerender="rerender"
                                @duplicate="duplicate"
                        ></calBooking>
                    </transition>
                </div>
                <div v-if="currentComponent=='BookingMultiple'">
                    <transition name="fade" appear>
                        <calBookingMultiple
                                :current="current"
                                :isEdited="isEdited"
                                :legend="legend"
                                :booking-multiple="bookingMultiple"
                                :activities="activities"
                                :met="met"
                                @closeBookingMultiple="closeComponent"
                                @editBookingMultipleGroup="fillBookingMultipleGroup"
                                @rerender="rerender"
                                @snotify="snotify"
                        ></calBookingMultiple>
                    </transition>
                </div>
                <div v-if="currentComponent=='BookingMultipleGroup'">
                    <transition name="fade" appear>
                        <calBookingMultipleGroup
                                :current="current"
                                :booking="bookingMultiple"
                                :legend="legend"
                                :users="users"
                                :renforts="renforts"
                                :isEdited="isEdited"
                                :quickCreate="quickCreate"
                                :met="met"
                                :redirectbillingroute="redirectbillingroute"
                                @closeBookingMultipleGroup="closeComponent"
                                @editBookingMultiple="editedBookingMultiple"
                                @rerender="rerender"
                                @snotify="snotify"
                        ></calBookingMultipleGroup>
                    </transition>
                </div>
                <div v-if="currentComponent=='Event'">
                    <transition name="fade" appear>
                        <calEvent
                                :users="users"
                                :legend="legend"
                                :current="current"
                                :isEdited="isEdited"
                                :renforts="renforts"
                                :met="met"
                                @rerender="rerender"
                                @getEvent="getEvent"
                                @snotify="snotify"
                                @closeEvent='closeComponent'
                        ></calEvent>
                    </transition>
                </div>
            </div>
        </div>
        <full-calendar v-if="eventsLoaded"
                       locale="fr"
                       class="calCusto"
                       ref="calendar"
                       :events="events"
                       :config="config"
                       @event-selected="eventSelected"
                       @event-resize="updateEvent"
                       @event-drop="droped"
                       @event-created="eventCreated"
                       @event-render="hover"
                       @view-render="viewRender">
        </full-calendar>
        <cal-graph v-if="type.type!='solo'" ref="calGraph"></cal-graph>
        <cal-hover ref="calHover" :users="users" :renforts="renforts" :participantsCount="participantsCount" :userType="type"></cal-hover>
    </div>
</template>

<script>
    import VueCtkDateTimePicker from 'vue-ctk-date-time-picker'
    import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css'
    import moment from 'moment';
    moment.locale('fr');
    /*import { FullCalendar } from 'vue-full-calendar';
    import 'fullcalendar/dist/locale/fr'
    import 'fullcalendar/dist/fullcalendar.css';
    import 'fullcalendar-scheduler/dist/scheduler.css';
    import 'fullcalendar-scheduler';*/

    export default {
        name: 'soloCalendar',
        components: {
            //FullCalendar,
            VueCtkDateTimePicker
        },
        props: {
            redirectbillingroute: {
                type: Array,
                default: () => {
                    return []
                }
            },
            users: {
                type: Array,
                default: () => {
                    return []
                }
            },
            activities: {
                type: Array,
                default: () => {
                    return []
                }
            },
            renforts: {
                type: Array,
                default: () => {
                    return []
                }
            },

            calendarResources: {
                type: Array,
                default: () => {
                    return []
                }
            },
            type:{
                type: Object,
                default: ()=>{
                    return []
                }
            },
            permissions: {
                type: Array,
                default:() =>{
                    return []
                }
            }
        },
        data() {
            return {
                showCal: true,
                customResource: moment().format('YYYY-MM-DD'),
                booking: {
                    eventId: '',
                    activity: '',
                    provider: '',
                    title: '',
                    rdv: '',
                    selectedCustomer: {},
                    comments: '',
                    eventStart: '',
                    eventEnd: '',
                    has_billing : '',
                    isPaid: false,
                    payment: ''
                },
                bookingMultiple:{
                    eventId:'',
                    total_places:0,
                    comment:'',
                    groups:[]
                },
                current: {
                    eventTitle: '',
                    eventStart: '',
                    eventEnd: '',
                    eventId: 0,
                    color: '#1FBC9C',
                    userId: '',
                    renfortId: '',
                    calendar_resourceId: '',
                    usersIds:[],
                    renfortsIds:[],
                    meeting_point:''
                },
                isEdited: Boolean,
                quickCreate: false,
                met: 'post',
                legend: 'Choisir une action :',
                selectedUser: null,
                events: [],
                currentComponent:null,
                isEdited: false,
                config:this.fullCalendarConfig(),
                selected: {},
                eventsLoaded:false
            }
        },
        created(){
            this.getEvent()
        },
        watch: {
            customResource: function(newVal, oldVal) {
                this.$refs.calendar.fireMethod('gotoDate', newVal)
            }
        },
        methods: {
            fullCalendarConfig(){
                //common config
                let commonConfig = {
                    displayEventTime : false,
                    schedulerLicenseKey: '0496185513-fcs-1554208496',
                    locale:'fr',
                    timezone:false,
                    editable: true,
                    //workaround to hide undefined in the title- we should remove this code when update the calendar
                    viewRender: function(view, element) {
                        $('.fc-center')[0].children[0].innerText = view.title.replace(new RegExp("undefined", 'g'), "");
                    }
                };

                //personnalized structure config
                let configStruct = {
                    header: {
                        right: 'month,timelineWeek,timeline'
                    },
                    resourceLabelText : 'Encadrants',
                    defaultView: "timeline",
                    resourceAreaWidth: '10%',
                    views: {
                        timeline: {
                            buttonText: 'Jour',
                            titleFormat: 'ddd Do MMM YYYY', //display for example lun. 2 sept. 2019 in day view
                            nowIndicator: true
                        },
                        timelineWeek: {
                            type: 'timeline',
                            buttonText: 'Semaine'
                        }
                    },
                    resourceGroupField: 'type',
                    resourceGroupText :function(resourceGroupField){
                        return resourceGroupField == 'user' ? 'Permanent(s)' : 'Ressource(s)'
                    },
                    resources: this.getAllResources()
                }

                let configDefaultHours = {
                    minTime: "08:00:00",
                    maxTime: "21:00:00",

                    businessHours:
                        {
                            start: '8:00',
                            end:   '19:00'
                        }
                }

                let configSolo = {
                    defaultView: "timelineWeek",
                    minTime: "07:00",
                    maxTime: "19:00",


                    businessHours:
                        {
                            start: '07:00',
                            end:   '19:00'
                        },
                    slotDuration:  '06:00',
                }

                //personnalized solo config
                let configBureau = {
                    duration: { days: 21 },
                    initialView: 'pastAndFutureView',
                    views: {
                        pastAndFutureView: {
                            visibleRange: function(currentDate) {
                                // Generate a new date for manipulating in the next step
                                var startDate = new Date(currentDate.valueOf());
                                var endDate = new Date(currentDate.valueOf());

                                // Adjust the start & end dates, respectively
                                startDate.setDate(startDate.getDate() ); // One day in the past
                                endDate.setDate(endDate.getDate() + 20); // Two days into the future

                                return { start: startDate, end: endDate };
                            }
                        }
                    }
                }

                let configAmbassador = {
                    editable:false,
                    minTime: "07:00",
                    maxTime: "21:00",

                    businessHours:
                        {
                            start: '07:00',
                            end:   '21:00'
                        },
                    header: {
                        left: 'prev,next',
                        center: 'title',
                        right: ''
                    },
                    defaultView: "month",
                }
                if(this.type.role=="ambassador"){
                    return Object.assign({}, commonConfig, configAmbassador);
                }

                console.log(this.type.type)
                //render config depending on user type
                switch(this.type.type){
                    case 'solo'://type solo
                        return Object.assign({}, commonConfig, configStruct, configSolo);
                    case 'bureau'://type bureau
                        return Object.assign({}, commonConfig, configStruct, configBureau);
                    default://type structure other than bureau
                        return Object.assign({}, commonConfig, configStruct, configDefaultHours);
                }
            },
            viewRender(event) {
                let isMonth = (event.name=='month')
                this.showCal = !isMonth
                this.displayBackgroundEvent(isMonth);
            },
            displayBackgroundEvent(monthView){
                let events = this.$refs.calendar.fireMethod('clientEvents', function(event) {
                    return (event.rendering == 'background' || event.className.includes('background'));
                });//get background event or event initially background
                for(let event of events){
                    if(!event.className.includes('background')){//save background attribute in class
                        event.className.push('background')
                    }
                    let enc =""
                    if(event.userId!=null){
                        enc = this.users.find(function(u){return u.id==event.userId}).fullName
                    }else{
                        enc = this.renforts.find(function(u){return u.id==event.renfortId}).fullName
                    }
                    event.title='Indispo - '+enc
                    if(this.type.type=="solo" && event.officeName){
                        event.title+=' ('+event.officeName+')'
                    }
                    event.editable=false
                    event.rendering = monthView?'':'background'
                    this.$refs.calendar.fireMethod('updateEvent',event);
                }
            },
            snotify() {
                this.$snotify.success('Calendrier mise à jour')
            },
            rerender() {
                this.$refs.calendar.$emit('rerender-events');
            },
            droped(event) {
                this.selected = event;
                const upEvent = {
                    event_id: this.selected.id,
                    start: this.selected.start,
                    end: this.selected.end,
                }
                if(event.bookingMultiple && Object.keys(event.bookingMultiple).length!=0){
                    //when bookingMultiple transform resourceId to resourcesIds
                    let resourcesIds = event.resourceIds!=null?event.resourceIds:[event.resourceId]
                    for(let resource of resourcesIds){
                        resource = resource.split('_')
                        if (resource[1] === 'U') {
                            (upEvent.users_ids = upEvent.users_ids || []).push(resource[0]);
                        } else {
                            (upEvent.renforts_ids = upEvent.renforts_ids || []).push(resource[0]);
                        }
                    }
                }else{//if not booking multiple or has only one resource
                    let resource = event.resourceId.split('_')
                    if (resource[1] === 'U') {
                        upEvent.user_id = resource[0]
                        upEvent.calendar_resource_id = null
                    } else {
                        upEvent.calendar_resource_id = resource[0]
                        upEvent.user_id = null
                    }
                }

                axios.put('calendar/event/' + this.selected.id + '/drop', upEvent )
                    .then(response => {
                        event.userId = response.data.event.user_id
                        event.calendar_resourceId = response.data.event.calendar_resource_id

                        let resourceIds = this.getResourceId(response.data.event)
                        if(Array.isArray(resourceIds)){//Multiple encadrants
                            formatedEvent.resourceIds=resourceIds
                        }else{
                            formatedEvent.resourceId=resourceIds
                        }

                        this.$refs.calendar.fireMethod('updateEvent', event);
                        this.$snotify.success('Evénement mise à jour')
                    })
                    .catch(error => {
                        this.getEvent()
                    });
            },
            eventCreated(event) {
                this.selected = event;
                this.booking.eventStart = this.selected.start.format()
                this.booking.eventEnd = this.selected.end.format()
                if (event.view.name ==="timeline" || event.view.name ==="timelineWeek") {
                    this.selected.resource.type === 'user' ? this.current.userId = this.selected.resource.resourceId : this.current.calendar_resourceId = this.selected.resource.resourceId
                    this.quickCreate = true
                } else {
                    this.quickCreate = false
                }
                this.openComponent("Booking",false,"Prendre un engagement")
            },
            updateEvent(event) {
                this.selected = event;
                const upEvent = {
                    event_id: event.id,
                    title: event.title,
                    start: event.start,
                    end: event.end,
                    user_id: event.userId,
                    renfort_id: event.renfortId,
                    resource_id: event.resourceId,
                    calendar_resource_id: event.calendar_resourceId,
                    activity_id: event.activity_id,
                    event_id: event.id,
                    customer: {
                        id: event.customer.id
                    }
                }
                axios.put('calendar/event/' + this.selected.id + '/drop', upEvent )
                    .then(response => {
                        this.$refs.calendar.$emit('rerender-events')
                        this.$snotify.success('Evénement mise à jour')
                    })
                    .catch(error => {
                        console.log(error.response)
                    });
            },
            getEvent() {
                console.log(this.calendarResources)
                axios.get('calendar/event')
                    .then((res) => {
                        this.eventsLoaded=true;
                        this.events = res.data.data.map(event => {
                            //for booking display customer name + event title as title
                            let eventTitle = event.booking != null ? event.booking.customer.fullName+' '+event.title:event.title;
                            let eventShortTitle = eventTitle//save title without participant
                            let eventBookingMultiple= {}
                            if(event.bookingMultiple && Object.keys(event.bookingMultiple).length!=0){
                                eventTitle+=" - "+this.participantsCount(event.bookingMultiple.groups)+"/"+event.bookingMultiple.total_places;
                                eventBookingMultiple = event.bookingMultiple;
                            }
                            let resourceIds = this.getResourceId(event)
                            let formatedEvent = {
                                id: event.id,
                                title: eventTitle,
                                shortTitle:eventShortTitle,
                                start: event.start,
                                end: event.end,
                                color: event.color,
                                userId: event.user_id,
                                renfortId: event.renfort_id,
                                calendar_resourceId: event.calendar_resource_id,
                                usersIds:event.users_ids,
                                renfortsIds:event.renforts_ids,
                                activity: event.activity != null ? event.activity: {},
                                booking: event.booking != null ? event.booking: {},
                                bookingMultiple: eventBookingMultiple,
                                meeting_point: event.meeting_point,
                                rendering: event.rendering,
                                officeName:event.officeName
                            }
                            if(Array.isArray(resourceIds)){//BookingMultiple encadrants
                                formatedEvent.resourceIds=resourceIds
                                formatedEvent.oldResourceIds=[]
                            }else{
                                formatedEvent.resourceId=resourceIds
                                formatedEvent.oldResourceId=null
                            }
                            return formatedEvent
                        })
                    })
            },
            getHistory() {
                axios.get('calendar/event/history')
                    .then((res) => {
                        this.eventsLoaded=true;
                        this.events = res.data.data.map(event => {
                            //for booking display customer name + event title as title
                            let eventTitle = event.booking != null ? event.booking.customer.fullName+' '+event.title:event.title;
                            let eventShortTitle = eventTitle//save title without participant
                            let eventBookingMultiple= {}
                            if(event.bookingMultiple && Object.keys(event.bookingMultiple).length!=0){
                                eventTitle+=" - "+this.participantsCount(event.bookingMultiple.groups)+"/"+event.bookingMultiple.total_places;
                                eventBookingMultiple = event.bookingMultiple;
                            }
                            let resourceIds = this.getResourceId(event)
                            let formatedEvent = {
                                id: event.id,
                                title: eventTitle,
                                shortTitle:eventShortTitle,
                                start: event.start,
                                end: event.end,
                                color: event.color,
                                userId: event.user_id,
                                calendar_resourceId: event.calendar_resource_id,
                                renfortId: event.renfort_id,
                                usersIds:event.users_ids,
                                renfortsIds:event.renforts_ids,
                                activity: event.activity != null ? event.activity: {},
                                booking: event.booking != null ? event.booking: {},
                                bookingMultiple: eventBookingMultiple,
                                meeting_point: event.meeting_point,
                                rendering: event.rendering,
                                officeName:event.officeName
                            }
                            if(Array.isArray(resourceIds)){//BookingMultiple encadrants
                                formatedEvent.resourceIds=resourceIds
                                formatedEvent.oldResourceIds=[]
                            }else{
                                formatedEvent.resourceId=resourceIds
                                formatedEvent.oldResourceId=null
                            }
                            return formatedEvent
                        })
                    })
            },
            eventSelected(event) {
                this.closeComponent()//close previously open component before opening a new one
                if(event.className.includes('background')){//cannot edit 'false' background event
                    return;
                }
                this.selected = event;
                if (this.selected.end === null) {
                    this.selected.end = this.selected.start
                }

                this.current.eventTitle = this.selected.title;
                this.current.eventShortTitle = this.selected.shortTitle;
                this.current.eventStart = this.selected.start
                this.current.eventEnd = this.selected.end
                this.current.eventId = this.selected.id
                this.current.color = this.selected.color
                this.current.userId = this.selected.userId
                this.current.renfortId = this.selected.renfortId
                this.current.calendar_resourceId = this.selected.calendar_resourceId
                this.current.usersIds = this.selected.usersIds
                this.current.renfortsIds = this.selected.renfortsIds
                this.current.meeting_point = this.selected.meeting_point
                this.current.activity = this.selected.activity.id

                this.booking.id = this.selected.booking.id
                this.booking.title = this.selected.title
                this.booking.eventStart = this.selected.start
                this.booking.eventEnd = this.selected.end
                this.booking.eventId = this.selected.id
                this.booking.provider = this.selected.userId
                this.booking.renfortId = this.selected.renfortId
                this.booking.calendar_resourceId = this.selected.calendar_resourceId
                this.booking.selectedCustomer = (this.selected.booking!=null)?this.selected.booking.customer:null
                this.booking.activity = this.selected.activity.id
                this.booking.comments = this.selected.booking.message
                this.booking.rdv = this.selected.meeting_point
                this.booking.has_billing = this.selected.booking.has_billing
                this.booking.isPaid = this.selected.booking.is_paid
                this.booking.payment = this.selected.booking.payment_method

                this.bookingMultiple.id = this.selected.bookingMultiple.id
                this.bookingMultiple.eventId=this.selected.bookingMultiple.event_id
                this.bookingMultiple.total_places=this.selected.bookingMultiple.total_places
                this.bookingMultiple.comment=this.selected.bookingMultiple.comment
                this.bookingMultiple.groups = this.selected.bookingMultiple.groups

                if(this.selected.bookingMultiple && Object.keys(this.selected.bookingMultiple).length !==0){//bookingMultiple
                    this.fillBookingMultipleGroup()
                }else if (this.booking.selectedCustomer && Object.keys(this.booking.selectedCustomer).length != 0){//booking
                    this.editedBooking()
                }else{//event
                    this.edited()
                }
            },
            closeComponent(){
                this.emptyObject()
                this.currentComponent=null
                this.legend = 'Choisir une action :'
            },
            duplicate(){
                this.met='post'
                this.isEdited=false
            },
            create() {
                this.openComponent("Event",false,"Créer un événement")
            },
            edited(){
                this.quickCreate = false
                this.openComponent("Event",true,"Modifier un événement")
            },
            editedBooking(){
                this.quickCreate = false
                this.openComponent("Booking",true,"Modifier un engagement")
            },
            editedBookingMultiple(){
                this.openComponent("BookingMultiple",true,"Modifier une collective")
            },
            fillBookingMultipleGroup(){
                this.openComponent("BookingMultipleGroup",true,"Remplir une collective")
            },
            bookingOpen() {
                this.openComponent("Booking",false,"Prendre un engagement")
            },
            bookingMultipleOpen(){
                this.bookingMultiple={}
                this.openComponent("BookingMultiple",false,"Créer une collective")
            },
            openComponent(component,isEdited,legend){
                this.$nextTick(function(){//wait if a component must close before opening this one
                    this.currentComponent=component
                    this.met=isEdited?"put":"post"
                    this.isEdited=isEdited
                    this.legend=legend
                })
            },
            emptyObject() {
                this.met = 'post'
                this.booking = {
                    activity: {},
                    provider: '',
                    renfortId: '',
                    calendar_resourceId: '',
                    id: '',
                    title: '',
                    rdv: '',
                    selectedCustomer: {},
                    comments: '',
                    isPaid: false,
                    eventStart: '',
                    eventEnd: '',
                    payment: '',
                    has_billing: '',
                    isPaid: false,
                    payment: ''
                }
                this.current = {
                    eventTitle: '',
                    eventStart: '',
                    eventEnd: '',
                    eventId: 0,
                    color: '#1FBC9C',
                    userId: '',
                    renfortId: '',
                    calendar_resourceId: '',
                    meeting_point:''
                }
            },
            getAllResources(){
                //merge users and renforts and return merged data as resources
                /*return this.users.concat(this.renforts).map(function (user) {
                    let prior=user.email_hash ? +user.pivot.priority+1 : +user.priority+1
                    return {
                        id: user.email_hash ? user.id + '_U' : user.id + '_R',
                        resourceId : user.id,
                        title : prior+'★ '+user.fullName,
                        type: user.email_hash ? 'user' : 'renfort'
                    }
                })*/

                return this.calendarResources.map(function (calendarResource) {
                    let prior=+calendarResource.priority+1
                    return {
                        id: calendarResource.id,
                        resourceId : calendarResource.id,
                        title : prior+'★ '+calendarResource.fullName,
                        type: 'calendarResource'
                    }
                })
            },
            getResourceId(data){
              //  console.log(data)
                return data.calendar_resource_id

              /*  if(!data.bookingMultiple || Object.keys(data.bookingMultiple).length==0){//if booking is not a bookingMultiple
                    return data.user_id ? data.user_id +'_U' : data.renfort_id +'_R'
                }
                if(data.users_ids.length+data.renforts_ids.length==0){//if no encadrant
                    return data.user_id+'_U'//display on author row
                }
                let ids=[]
                for(let id of data.users_ids){
                    ids.push(id+'_U')
                }
                for(let id of data.renforts_ids){
                    ids.push(id+'_R')
                }
                return ids*/
            },
            currentdayevents(e){
                let href = 'calendar/event/currentdayevents/'+this.$refs.calendar.fireMethod('getDate').format('YYYY-MM-DD')
                $("#currentdayevents-btn").attr("href",href)
            },
            displayGraph(){
                this.$refs.calGraph.loadGraph()
            },
            hover(...args){
                this.$refs.calHover.hover(...args)
            },
            participantsCount(groups){
                if(groups.length<=0){
                    return 0
                }
                return groups.reduce(function(acc, current){
                    let count = current!=null?parseInt(current.group_count):0
                    return acc+count
                },0);
            },
        }
    };
</script>

<style scoped>
    .fade-enter-active, .fade-leave-active {
        transition: opacity .8s;
    }
    .fade-enter, .fade-leave-to {
        opacity: 0;
    }
    .content-spaceB {
        display: flex;
        justify-content: space-between;
    }
    #btnGraph {
        background-color: #114753;
        color:white;
    }
    .btnBooking {
        background-color: #114753;
        color:white;
    }
    .btnBooking:hover {
        background-color: #275F6C;
    }
    .calCusto >>> .background {
        opacity: 0.3;
        cursor: default;
    }
    /* >>> to query element in child component. ex: .componentClass >>> .childClass */
    .calCusto >>> .fc-slats {
        z-index: 1 !important;/*To put grid behind event and make event clickable for agenda*/
    }
    @media only screen and (max-width: 408px) {/*for calendar button on 1 line*/
        .calCusto >>> .fc-button {
            padding: 0.2em  !important;
        }
        .calCusto >>> .fc-today-button {
            margin-left: 0 !important;
        }
        .calCusto >>> .fc-icon-right-single-arrow, .calCusto >>> .fc-icon-left-single-arrow {
            margin: 0 !important;
        }
        .calCusto >>> .fc-prev-button, .calCusto >>> .fc-next-button {
            display: none
        }
    }
    @media only screen and (max-width: 576px) {/*bootstrap xs equivalent*/
        .no-h-padding {
            padding-left: 0 !important;
            padding-right: 0 !important;
        }
        .no-left-padding {
            padding-left: 0 !important;
        }
        .no-right-padding {
            padding-right: 0 !important;
        }
        .event-buttons-group {
            margin-bottom: 0.5rem;
        }
        .calCusto >>> .fc-header-toolbar {
            margin-bottom: 0 !important;
        }
    }
</style>
